import { useEffect, useState } from "react";
import { GridRowData } from "@mui/x-data-grid";

import Table from "../../components/table";

import { devicesApi } from "../../api";
import { Device } from "../../api/types/devices";

import classes from "./index.module.scss";
import UnitData from "../../components/_modals/UnitData";

const unitsTableColumns = [
  { field: "uid", headerName: "Device ID", sortable: false, flex: 1 },
  { field: "status", headerName: "Status", type: "string", width: 200 },
  { field: "created_at", headerName: "Added on", type: "date", width: 250 },
];

const Units = () => {
  const [tableData, setTableData] = useState<GridRowData[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [unitDataOpen, setUnitDataOpen] = useState<boolean>(false);
  const [selectedUnit, setSelectedUnit] = useState<Device>();

  useEffect(() => {
    const updateDevices = async () => {
      setIsLoading(true);
      await devicesApi.getAllDevices({ withLocation: false }).then((data) => {
        if (data.status < 400) {
          const { devices } = data.params;
          setTableData(formatTableData(devices));
        }
        setIsLoading(false);
      });
    };

    updateDevices();
  }, []);

  const formatTableData = (items: Device[]) => {
    return items.map((el) => {
      return {
        uid: el.device_id,
        status: el.status,
        created_at: new Date(el.created_at).toDateString(),
      };
    });
  };

  const handleRowClick = (value: any) => {
    setUnitDataOpen(true);
    setSelectedUnit(value);
  };

  return (
    <div className={classes.root}>
      <Table
        {...{ isLoading }}
        columns={unitsTableColumns}
        dataSet={tableData}
        showSearch
        onRowClick={handleRowClick}
      />
      {selectedUnit && (
        <UnitData
          open={unitDataOpen}
          onClose={() => setUnitDataOpen(false)}
          unit={selectedUnit}
        />
      )}
    </div>
  );
};

export default Units;
